import { Response } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { ToastController } from 'ionic-angular';
import { VasAppFacade } from '../../vas/services/vas-app-facade.service';
import { AppFacade } from '../services/app-facade/app-facade.service';
import { getErrorMessage } from '../util/get-error-message';

export class ToastFacade {

    constructor(protected appFacade: AppFacade, protected toastController: ToastController, protected translateService: TranslateService) {

    }

    toastDanger(message: string | Error | Response, options?, callback?): Promise<any> {
        console.error(message);

        if (message instanceof Error) {
            try {
                (this.appFacade as VasAppFacade).errorHandler.handleError(message);
            } catch (e) {
                // ignore
            }
        }

        return this.toast(message, {
            ...options,
            duration: 5000,
            cssClass: 'toast-danger'
        }, callback);
    }

    toastWarning(message: string | Error | Response, options?, callback?): Promise<any> {

        return this.toast(message, {
            ...options,
            cssClass: 'toast-warning'
        }, callback);
    }

    toast(message: string | Error | Response, options: any = {}, callback?): Promise<any> {

        const interpolateParams = options.interpolateParams || {};

        const t = this.toastController.create({
            ...{
                message: this.translateService.instant(getErrorMessage(message) || 'UNKNOWN_ERROR', interpolateParams),
                duration: 3000,
                position: 'top',
                showCloseButton: true,
                dismissOnPageChange: false,
                cssClass: 'toast-default'
            },
            ...options
        });

        if (callback) {
            t.onDidDismiss(callback);
        }

        return t.present();
    }
}



// WEBPACK FOOTER //
// ./src/core/facades/toast-facade.ts